export const ACCOUNT_MENU_DARK_KEY = 'accountMenuDarkMode';
export const ACCOUNT_MENU_DARK_EVENT = 'accountMenuDarkModeChange';

export function readAccountMenuDarkMode() {
  return localStorage.getItem(ACCOUNT_MENU_DARK_KEY) === 'true';
}

export function writeAccountMenuDarkMode(enabled) {
  localStorage.setItem(ACCOUNT_MENU_DARK_KEY, enabled ? 'true' : 'false');
  window.dispatchEvent(
    new CustomEvent(ACCOUNT_MENU_DARK_EVENT, { detail: { enabled } })
  );
}
